
import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

interface RecentResultsChartProps {
  recentResults: any[];
}

const RecentResultsChart: React.FC<RecentResultsChartProps> = ({ recentResults }) => {
  const { t } = useTranslation('dashboard');
  
  // Définition des catégories de jeu pour l'organisation des liens
  const gameCategories = {
    shortGame: [
      { name: t('results.categories.putting'), path: "/training/putting" },
      { name: t('results.categories.chipping'), path: "/training/chipping" },
      { name: t('results.categories.wedging'), path: "/training/wedging" },
      { name: t('results.categories.bunker'), path: "/training/bunker" }
    ],
    longGame: [
      { name: t('results.categories.ironWood'), path: "/training/swing" },
      { name: t('results.categories.driver'), path: "/training/driver" }
    ]
  };
  
  // Si aucun résultat, afficher un message d'information
  if (recentResults.length === 0) {
    return (
      <Card className="col-span-full">
        <CardContent className="py-6 text-center">
          <p className="text-muted-foreground">
            {t('results.noResults')}
          </p>
        </CardContent>
      </Card>
    );
  }
  
  return (
    <Card className="col-span-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{t('results.accessTitle')}</CardTitle>
      </CardHeader>
      
      <CardContent className="pt-0">
        <div className="mb-6">
          <h3 className="text-sm font-medium mb-2">{t('results.shortGame')}</h3>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
            {gameCategories.shortGame.map((item) => (
              <Button 
                key={item.path}
                variant="outline" 
                className="bg-golf-600 text-white hover:bg-golf-700"
                asChild
              >
                <Link to={item.path}>
                  {item.name} <ChevronRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
            ))}
          </div>
        </div>
        
        <div className="mb-4">
          <h3 className="text-sm font-medium mb-2">{t('results.longGame')}</h3>
          <div className="grid grid-cols-2 gap-2">
            {gameCategories.longGame.map((item) => (
              <Button 
                key={item.path}
                variant="outline" 
                className="bg-golf-600 text-white hover:bg-golf-700"
                asChild
              >
                <Link to={item.path}>
                  {item.name} <ChevronRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium mb-2">{t('results.courseStats')}</h3>
          <div className="grid grid-cols-2 gap-2">
            <Button 
              variant="outline" 
              className="bg-golf-600 text-white hover:bg-golf-700"
              asChild
            >
              <Link to="/course-stats">
                {t('results.categories.course')} <ChevronRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentResultsChart;
